import { render } from "./PasswordInput.vue?vue&type=template&id=9345d4ba&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=js"
export * from "./PasswordInput.vue?vue&type=script&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=9345d4ba&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9345d4ba"]])

export default __exports__